import { useMemo } from 'react';

function useMobileAgent() {
  const details = navigator.userAgent;

  const regexp = /android|iphone|kindle|ipad/i;
  const androidRegex = /android/i;

  const isMobileDevice = regexp.test(details);

  const isAndroidDevice = androidRegex.test(details);

  return useMemo(
    () => [isMobileDevice, isAndroidDevice],
    [isMobileDevice, isAndroidDevice]
  );
}

export default useMobileAgent;
